import dayjs from "dayjs";

export const send = async (notification, authHeaderValue) => {
  try {
    const url = `${process.env.REACT_APP_SERVER_URI}/v1/admin/notifications/push-notifications`;
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({
        ...notification,
        expiresAt: dayjs(notification.expiresAt).toISOString(),
      }),
      headers: {
        Authorization: authHeaderValue,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }
  } catch (error) {
    console.log(error);
    throw new Error("Couldn't create notification");
  }
};

export const updateNotification = async (notification, authHeaderValue) => {
  try {
    const url = `${process.env.REACT_APP_SERVER_URI}/v1/admin/notifications/push-notifications/${notification.id}`;
    const response = await fetch(url, {
      method: "PUT",
      body: JSON.stringify({
        ...notification,
        expiresAt: dayjs(notification.expiresAt).toISOString(),
      }),
      headers: {
        Authorization: authHeaderValue,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }
  } catch (error) {
    console.log(error);
    throw new Error("Couldn't update notification");
  }
};

export const deleteNotification = async (notificationId, authHeaderValue) => {
  try {
    const url = `${process.env.REACT_APP_SERVER_URI}/v1/admin/notifications/push-notifications/${notificationId}`;
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        Authorization: authHeaderValue,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }
  } catch (error) {
    console.log(error);
    throw new Error("Couldn't delete notification");
  }
};
